import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#ffff">
      <path d="M16.822 5.134A4.75 4.75 0 0 1 15.648 2h-.919a4.763 4.763 0 0 0 2.093 3.134ZM8.322 11.905a2.89 2.89 0 0 0-2.886 2.888c0 1.11.63 2.076 1.55 2.559a2.859 2.859 0 0 1-.548-1.686 2.89 2.89 0 0 1 2.886-2.888c.297 0 .585.05.854.134v-3.51a6.419 6.419 0 0 0-.854-.06c-.051 0-.097.004-.149.004v2.693a2.905 2.905 0 0 0-.853-.134Z" />
      <path d="M19.424 6.676v2.67a8.172 8.172 0 0 1-4.778-1.537v6.989c0 3.487-2.835 6.329-6.324 6.329a6.296 6.296 0 0 1-3.624-1.147A6.312 6.312 0 0 0 9.324 22c3.484 0 6.324-2.837 6.324-6.33V8.683a8.172 8.172 0 0 0 4.779 1.537V6.783a4.7 4.7 0 0 1-1.003-.107Z" />
      <path d="M14.646 14.798V7.809a8.172 8.172 0 0 0 4.778 1.537v-2.67a4.773 4.773 0 0 1-2.602-1.542A4.802 4.802 0 0 1 14.725 2H12.21l-.005 13.777a2.89 2.89 0 0 1-2.881 2.782 2.898 2.898 0 0 1-2.343-1.203 2.899 2.899 0 0 1-1.55-2.558 2.89 2.89 0 0 1 2.886-2.889c.297 0 .585.051.854.135V9.351C5.756 9.425 3 12.23 3 15.67a6.31 6.31 0 0 0 1.698 4.309 6.296 6.296 0 0 0 3.624 1.147c3.484 0 6.324-2.842 6.324-6.33Z" />
    </g>
  </svg>
)
export default SvgComponent
